import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// Self-hosted fonts — no external font CDN requests.
import "@fontsource-variable/inter";
import "@fontsource-variable/noto-sans-sc";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "@anyseal/ui/styles.css";
import "./styles/pages.css";
import { App } from "./App";
import { AuthProvider } from "./auth";
import { I18nProvider } from "./i18n";
import { WorkspaceProvider } from "./workspace";
import { ThemeProvider } from "./useTheme";

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 20_000, refetchOnWindowFocus: false } } });
const root = document.getElementById("root");
if (!root) throw new Error("Portal root element is missing");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <I18nProvider><ThemeProvider><AuthProvider><WorkspaceProvider><App /></WorkspaceProvider></AuthProvider></ThemeProvider></I18nProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
